<template>
  <div>
    <b-card class="standardpage">
      <b-card-header id="tooltip-charters">
        <b-row>
          <b-col cols="10" class="text-sm-left pt-1">
            <i :class="charters.icon" class="mr-1"></i>
            {{ charters.title }}
            <span v-if="eventtitle"> for {{ eventtitle }} </span>
          </b-col>

          <b-col cols="2" class="text-right legend-pt-7px">
            <b-form-group label-cols="auto" label="Year:" label-size="sm">
              <treeselect placeholder="Select year" v-model="year" :clearable="false" :multiple="false"
                :options="options_year" @input="events()">
              </treeselect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-header>
      <!-- {{ this.options_year }} -->
      <div v-if="!component" class="availtable datatable">
        <b-nav class="ml-3 mt-1" small pills>
          <b-nav-item class="nav-pills-hover-effect" small v-for="evt in eventcodes" :key="evt"
            @click="eventcode = evt; eventtitle = ''" :active="eventcode == evt">{{ evt }}</b-nav-item>
        </b-nav>

        <b-nav class="ml-3 mt-1" small pills v-if="eventcodes.length == 0">
          <b-nav-item active class="nav-pills default disabled" small>* NO EVENTS *</b-nav-item>
        </b-nav>

        <b-card class="w-100pct mb-3">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." v-model="eventcode" :clearable="true" :async="true"
                    :load-options="treeselect_loadEvent" searchPromptText="Type at least 4 chars..." :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                    @select="treeselect">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Direction" label-size="sm">
                  <treeselect placeholder="Any" v-model="direction" :clearable="true" :multiple="true"
                    :options="options_direction">
                  </treeselect>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <b-input-group>
                    <b-form-datepicker v-model="datetravel" size="sm" label-help hide-header locale="en-GB"
                      placeholder="Select date" :start-weekday="1" :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"></b-form-datepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="datetravel = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Routing" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="routing" :debounce="charters.debounce" placeholder="Routing"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!routing" @click="routing = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Locator ( Paste List )" label-for="locator" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="locator" v-model="locator" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Locator" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="locator = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker size="sm" ref="datetravel" v-model="datetravel" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="false">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="false" @click="
                        datetravel = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="FlightNo" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="flightno" :debounce="charters.debounce"
                      placeholder="FlightNo"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!flightno" @click="flightno = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Class" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="classcode" :debounce="charters.debounce" placeholder="Class"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!classcode" @click="classcode = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>




            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="charters" :icon="charters.icon"
            :toolbarlibrary="charters.toolbarlibrary" :tools="charters.tools" :badges="charters.badges"
            :fields="charters.fields" :items="charters.items" :busy="charters.busy" :limit="charters.limit"
            :downloaded="charters.downloaded" :page="charters.page" :showpages="true" @load="charters_load"
            @click="charters_click" @select="charters_select">
          </d-table>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="charters.selected" :config="cconfig" @discard="charters_click('discard')"
          @refresh="charters_click('refresh')"></component>
      </div>

      <b-row class="px-3">
        <b-col>
          <b-alert :show="unticketed > 0 && !component" variant="danger">
            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                There are still {{ unticketed }} seat(s) in this event that need to be released.</b-col></b-row>
          </b-alert></b-col>
      </b-row>

    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import CharterRelease from "./Components/CharterRelease";
import ChartersEdit from "./Components/ChartersEdit";

export default {
  name: "Charters",
  components: {
    CharterRelease,
    ChartersEdit,
  },
  async mounted() {
    this.accessdenied();

    this.year = this.$moment().format("YYYY")

    let year_start = parseInt(this.$moment().format("YYYY"))
    let year_end = 2022


    for (var i = parseInt(this.$moment().format('YYYY')); i >= year_end; i--) {
      this.options_year.push({ id: i.toString(), label: i.toString() })
    }

    await this.events();

  },
  data() {
    return {
      busy: false,
      readonly: false,
      year: "",
      eventcodes: [],
      eventcode: null,
      direction: [],
      flightno: null,
      routing: null,
      classcode: null,
      locator: [],
      datetravel: {
        startDate: null,
        endDate: null,
      },
      options_year: [],
      options_direction: [
        { id: "return", label: "Return" },
        { id: "outbound", label: "Outbound" },
        { id: "inbound", label: "Inbound" },
        { id: "additional", label: "Additional" },
      ],
      charters: {
        title: "Charters",
        icon: "fa fa-fighter-jet text-info",
        debounce: 500,
        busy: false,
        selectall: false,
        page: 1,
        offset: 0,
        limit: 15,
        denied: [],
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-stack-overflow text-primary",
            position: "toolbar,actions",
            action: "release",
            label: "Release",
            component: {
              name: "CharterRelease",
            },
          },
        ],
        tools: "go,filter,download,clipboard,add,edit,release,deleteconfirm",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-50px",
          },
          {
            key: "direction",
            label: "Direction",
            sortable: true,
            class: "text-center",
          },
          {
            key: "locator",
            label: "Locator",
            sortable: true,
            class: "text-center",
          },
          {
            key: "startdate",
            label: "Departure",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              let result = "Never";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("ddd DD/MM/YYYY HH:mm");
              }
              return result;
            },
          },
          {
            key: "routing",
            label: "Routing",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 20) {
                  result = result.slice(0, 17) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "flightno",
            label: "FlightNo",
            sortable: true,
            class: "d-none d-lg-table-cell text-center",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 14) {
                  result = result.slice(0, 14) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "classcode",
            label: "Class",
            sortable: true,
            class: "d-none d-lg-table-cell text-center",
          },
          {
            key: "aircraft",
            label: "Aircraft",
            sortable: true,
          },
          {
            key: "fare_type",
            label: "Fare Type",
            sortable: true,
          },
          {
            key: "total",
            label: "Total",
            sortable: true,
            class: "text-center",
            totalled: true,
            type: "int",
            total: 0,
          },
          {
            key: "booked",
            label: "Booked",
            sortable: true,
            class: "text-center",
            totalled: true,
            type: "int",
            total: 0,
          },
          {
            key: "free",
            label: "Free",
            sortable: true,
            class: "text-center",
            totalled: true,
            type: "int",
            total: 0,
          },
          {
            key: "options",
            label: "Options",
            sortable: true,
            class: "text-center",
            totalled: true,
            type: "int",
            total: 0,
          },
          {
            key: "unticketed",
            label: "Unticketed",
            sortable: true,
            class: "text-center",
            totalled: true,
            type: "int",
            total: 0,
          },
          {
            key: "issued_at",
            label: "Date Tickets",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "Never";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY HH:mm");
              }
              return result;
            },
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-right",
            // formatter: (value, key, item) => {
            //   let result = "Never";
            //   if (value) {
            //     result = this.$moment
            //       .unix(value / 1000)
            //       .format("DD/MM/YYYY hh:mm");
            //   }
            //   return result;
            // },
          },
          // {
          //   key: "fare_type",
          //   label: "Fare Type",
          //   sortable: true,
          //   class: "text-center ",
          // },
          // {
          //   key: "fare",
          //   label: "Fare",
          //   sortable: true,
          //   class: "text-right",
          //   totalled: true,
          //   total: 0,
          // },
          // {
          //   key: "tax",
          //   label: "Tax",
          //   sortable: true,
          //   class: "text-right",
          //   totalled: true,
          //   total: 0,
          // },
          // {
          //   key: "fare_sell",
          //   label: "Sell",
          //   sortable: true,
          //   class: "text-right",
          //   totalled: true,
          //   total: 0,
          // },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-120px",
          },
        ],
        badges: [
          {
            key: "grouptype",
            type: "badge",
            charter: "teal",
            gds: "danger",
          },
          {
            key: "direction",
            type: "badge",
            outbound: "success",
            inbound: "warning",
            additional: "info",
            return: "purple",
          },
          {
            key: "fare_type",
            type: "badge",
            Unknown: "white",
            Negotiated: "warning",
            Net: "purple",
            Manual: "secondary",
            Published: "white",
            Private: "pink",
            other: "secondary",
            'Mixed-ch': "white",
            'Private-ch': "pink",
            formatter: (value, key, item) => {
              if (value) {
                switch (value.toLowerCase()) {
                  case "unknown":
                    return "Unknown";

                  case "negotiated":
                    return "Negotiated";

                  case "net":
                    return "Net";

                  case "manual":
                    return "Manual";

                  case "published":
                    return "Published";

                  case "private":
                    return "Private";

                  case "mixed-ch":
                    return "Mixed-ch";

                  case "private-ch":
                    return "Private-ch";

                  default:
                    return value;
                }
              }
            },
          },
          {
            key: "classcode",
            type: "pill",
            class: "purple",
          },
          {
            key: "locator",
            type: "pill",
            class: "secondary",
          },
          {
            key: "aircraft",
            type: "pill",
            class: "purple",
          },
          {
            key: "free",
            type: "pill",
            class: "info",
          },
          {
            key: "booked",
            type: "pill",
            class: "success",
          },
          {
            key: "unticketed",
            type: "pill",
            class: "danger",
          },
          {
            key: "options",
            type: "pill",
            class: "secondary",
          },
          {
            key: "total",
            type: "pill",
            class: "white",
          },

        ],
        items: [],
        selected: [],
        downloaded: [],
      },
      unticketed: 0
    };
  },
  watch: {
    async eventcode() {
      this.unticketed = 0
      this.charters.items = []
      if (this.eventcode) {
        await this.charters_load(0);
      }
    },
    async direction() {
      await this.charters_load(0);
    },
    async locator() {
      await this.charters_load(0);
    },
    async datetravel() {
      await this.charters_load(0);
    },
    async flightno() {
      await this.charters_load(0);
    },
    async classcode() {
      await this.charters_load(0);
    },
    async routing() {
      await this.charters_load(0);
    },
  },

  methods: {
    accessdenied() {
      if (!this.user.permissions.includes("charters.delete")) {
        this.charters.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("charters.save")) {
        this.charters.denied.push("save");
      }
    },
    async events() {

      this.unticketed = 0
      this.charters.items = []

      this.eventcode = null
      this.direction = []
      this.flightno = null
      this.routing = null
      this.classcode = null
      this.locator = []
      this.datetravel = {
        startDate: null,
        endDate: null,
      }

      let variables = {
        year: this.year
      }
      try {
        const response = await this.$apollo.query({
          query: gql`
            query grouppnrs_events($year: String) {
              grouppnrs_events( year: $year)
            }
            `,
          variables,
        });

        this.eventcodes = response.data.grouppnrs_events
        if (this.eventcodes.length > 0) {
          this.eventcode = this.eventcodes[this.eventcodes.length - 1]
        }

      } catch (error) {
        console.log(error);
      }
    },
    async unticketedcount() {

      this.unticketed = 0
      if (this.eventcode) {

        let variables = {
          limit: 0,
          grouptype: "charter",
          eventcode: this.eventcode
        }

        try {
          const response = await this.$apollo.query({
            query: gql`
            query grouppnrs(
              $limit: Int
              $grouptype: String
              $eventcode: String
              ) {
              grouppnrs(
                limit: $limit
                grouptype: $grouptype
                eventcode: $eventcode
              ){
                id
                unticketed
              }
            }
          `,
            variables,
          });

          this.unticketed = 0
          for (var i = 0; i < response.data.grouppnrs.length; ++i) {
            this.unticketed += parseInt(response.data.grouppnrs[i].unticketed)
          }


        } catch (error) {
          console.log(error);
        }
      }


    },
    async charters_load(offset, limit, page) {

      if (!this.eventcode) { return }

      let state = this.charters;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;



      // if (page) {
      //   this.charters.page = page
      // }

      this.unticketed = 0
      // this.charters.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        grouptype: "charter",
        eventcode: this.eventcode,
        direction: this.direction ? this.direction.join(',') : null,
        locator: this.locator.length > 0 ? this.locator.join(",") : null,
        // datetravel: this.datetravel,
        datetravel: [
          this.$moment(this.datetravel.startDate).format("YYYY-MM-DD"),
          this.$moment(this.datetravel.endDate).format("YYYY-MM-DD"),
        ],
        flightno: this.flightno,
        classcode: this.classcode,
        routing: this.routing
      };

      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query grouppnrs(
              $offset: Int
              $limit: Int
              $eventcode: String
              $grouptype: String
              $groupname: String
              $direction: String
              $locator: String
              $flightno: String
              $classcode: String
              $routing: String
              $datetravel: [String]
              $agent: String
            ) {
              grouppnrs(
                offset: $offset
                limit: $limit
                eventcode: $eventcode
                grouptype: $grouptype
                groupname: $groupname
                direction: $direction
                locator: $locator
                flightno: $flightno
                classcode: $classcode
                routing: $routing
                datetravel: $datetravel
                agent: $agent
              ) {
                id
                grouptype
                eventcode
                direction
                locator                
                groupname
                source
                branch 
                agent
                notes
                routing
                startdate
                flightno
                classcode
                aircraft
                fare_type
                total
                options
                booked
                free
                unticketed
                issued_at
                data    
                updated_by
                updated_at
                rows
              }
            }
          `,
          variables,
        });

        // if (this.charters.selectall) {
        //   this.charters.selected = response.data.grouppnrs;
        // } else {

        // USE LOCAL VARIABLE
        // if (limit == 0) {
        //   state.selected = response.data.grouppnrs
        // } else {
        //   state.items = []
        //   state.items = response.data.grouppnrs;
        // }

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.grouppnrs
        } else {
          state.items = []
          state.items = response.data.grouppnrs;
        }


        // if (limit == 0) {
        //   this.charters.selected = this.cleanit(response.data.grouppnrs);
        // } else {
        //   this.charters.items = response.data.grouppnrs;

        await this.unticketedcount()

        //}
        // }
      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },

    async charters_click(a, ss) {

      let state = this.charters;

      switch (a) {
        case "selectall":
          // state.selectall = !state.selectall;
          await this.charters_load(0, 0);
          break;

        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.charters_load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          await this.charters_load(0);
          break;

        case "refresh":
        case "go":
          this.component = null;
          await this.charters_load();
          break;
        case "add":
        case "edit":
          this.component = "ChartersEdit";
          break;

        case "release":
          this.component = "CharterRelease";
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async charters_select(ss, tools) {
      console.log("charters_select", ss);

      let state = this.charters;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = [
          "back",
          "save",
          "go",
          "filter",
          "add",
          "download",
          "releasecharter",
          "clipboard"
        ];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm", "release"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async deleteit(s) {
      console.log("deleteit", s);

      let state = this.charters;
      state.busy = true

      let rows = [];
      s.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation grouppnrs_delete($rows: [GroupPnr_input]) {
              grouppnrs_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      state.busy = false
      await this.charters_load();
    },
  },
};
</script>